import { YOUTUBE_MAX_TITLE_CHARS } from './constants';

export function formatYouTubeTitle(val: string) {
  if (typeof val !== 'string') {
    return undefined;
  }

  return val.substring(0, YOUTUBE_MAX_TITLE_CHARS);
}
